import React, {useEffect, useState} from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay, Table, TableContainer, Tbody, Td, Thead, Tr
} from "@chakra-ui/react";
import {filterNonNumeric, toEnglishNumber, toPersianNumber} from "../utils/numberConversion";
import {toast} from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import {DatePicker, TimePicker} from "zaman";
import {format} from "date-fns";
import {getJalaliDate} from "../utils/dateConversion";


function BundleModal({isOpen, onClose, bundle, setRefresh}) {

    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [price, setPrice] = useState(0);
    const [files,setFiles] = useState([])
    const loadFiles = async () => {
        try {
            const response = await api.get(`/api/bundle/${bundle?.id}/files`);
            setFiles(response.data.data);
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    useEffect(() => {
        if (bundle) {
            loadFiles()
            setId(bundle.id)
            setName(bundle.name)
            setPrice(bundle.total_price)
        } else {
            setId('')
            setName('')
            setPrice(0)
        }
    }, [isOpen]);
    const handlePrice = (e) => {
        setPrice(toPersianNumber(filterNonNumeric(e.target.value)));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || name === "" || !price && price !== 0) {
            toast.error("فرم را کامل کنید!", {
                position: "bottom-right"
            });
            return;
        }
        try {
            const response = await api.post(id !== '' ? `/api/bundle/${id}` : `/api/bundle`, {
                name: name,
                total_price: toEnglishNumber(price),
            });
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            setRefresh(true);
            onClose();
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }

    }
    const deleteFile = async (file_id) => {
        try {
            const response = await api.get(`/api/bundle/${id}/files/delete/${file_id}`);
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            setRefresh(true);
            onClose();
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }

    }
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>افزودن مجموعه فایل </ModalHeader>
                <ModalCloseButton/>
                <form onSubmit={handleSubmit}>
                    <ModalBody className="exam-modal">

                        <div className="custom-input-group">
                            <label>نام مجموعه</label>
                            <input type="text" className={`form-control ${name?.length > 32 ? 'invalid' : ''}`}
                                   value={name}
                                   onChange={(e) => {
                                       setName(toPersianNumber(e.target.value))
                                   }}
                                   placeholder="نام مجموعه"/>
                            <p className={`form-error ${name?.length > 32 ? 'visible' : 'hidden'}`}>نام آزمون نمی تواند
                                بیشتر از ۳۲ کاراکتر باشد.</p>
                        </div>
                        <div className="custom-input-group">
                            <label>قیمت</label>
                            <input type="text" className='form-control'
                                   value={price}
                                   onChange={handlePrice}
                                   placeholder="قیمت( به تومان)" autoComplete="true"/>
                        </div>
                        <div className={'table-container p-0'}>
                            <TableContainer>
                                <Table variant="striped" colorScheme="teal">
                                    <Thead>
                                        <Tr>
                                            <Td>ردیف</Td>
                                            <Td>نام</Td>
                                            <Td>قیمت تک محصول</Td>
                                            <Td>حذف</Td>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {files.map((file, index) => (
                                            <Tr>
                                                <Td>{toPersianNumber(index+1)}</Td>
                                                <Td>{toPersianNumber(file.name)}</Td>
                                                <Td>{toPersianNumber(file.price)} تومان</Td>
                                                <Td>
                                                    <button
                                                        className={`btn btn-outline-red`}
                                                        onClick={() => {
                                                            deleteFile(file.id);
                                                        }}
                                                    >
                                                        حذف
                                                    </button>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                            بستن
                        </Button>
                        <Button colorScheme='green' type='submit'>ثبت</Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
}

function DeleteBundleModal({isOpen, onCloseDelete, bundle, setRefresh}) {
    const [name, setName] = useState('');
    const [id, setID] = useState(0);
    useEffect(() => {
        if (isOpen) {
            if (bundle) {
                setID(bundle.id)
                setName(bundle.name)
            } else
                onCloseDelete();
        }
    }, [isOpen]);
    const handleSubmit = async (e) => {
        try {
            const response = await api.get("/api/bundle/delete/" + id);
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            setRefresh(true);
            onCloseDelete();
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }

    }
    return (
        <Modal isOpen={isOpen} onClose={onCloseDelete}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>حذف مجموعه فایل {name}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody className="exam-modal">
                    <p>آیا از حذف این مجموعه اطمینان دارید؟</p>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='gray' mr={3} onClick={onCloseDelete} marginX={'1rem'}>
                        بستن
                    </Button>
                    <Button colorScheme='red' onClick={handleSubmit}>حذف</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export {BundleModal, DeleteBundleModal};